import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { DeleteShipmentKit, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* deleteShipmentKitSaga(action: DeleteShipmentKit) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeSplit, action.payload.shipmentId, action.payload.kitItemId);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.removeItems(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteShipmentKit() {
  yield takeEvery(LogisticsActionKeys.DELETE_SHIPMENT_KIT, deleteShipmentKitSaga);
}

async function executeSplit(
  shipmentId: number,
  kitItemId: string
): Promise<IApiExecuteRespone<IEntityWithMessages<number[]>>> {
  return executeApiRequest(() => httpService.delete(`${ApiUrls.shipment(shipmentId)}/RemoveKit/${kitItemId}`));
}
